import { useState } from "react";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/axios";

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      navigate("/feed");
    } catch (requestError) {
      setError(requestError?.response?.data?.error || "No pudimos cambiar la contraseña. El enlace puede haber caducado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="page-band">
      <Row className="justify-content-center">
        <Col md={7} lg={5}>
          <Card className="cardora-card">
            <Card.Body>
              <h1 className="section-title mb-3">Nueva contraseña</h1>
              {!token && (
                <Alert variant="warning" className="page-feedback">
                  Falta el token de recuperación. Pide un nuevo enlace.
                </Alert>
              )}
              {error && <Alert variant="danger" className="page-feedback">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="newPassword">
                  <Form.Label>Nueva contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={event => setPassword(event.target.value)}
                    minLength={8}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="confirmPassword">
                  <Form.Label>Confirmar contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    value={confirmPassword}
                    onChange={event => setConfirmPassword(event.target.value)}
                    minLength={8}
                    required
                  />
                </Form.Group>
                <Button type="submit" className="btn-cardora w-100" disabled={loading || !token}>
                  {loading ? "Guardando..." : "Guardar contraseña"}
                </Button>
              </Form>
              <p className="auth-legal-copy">
                <Link to="/forgot-password">Pedir otro enlace</Link>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
